// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c9374aa4","455":"4079bde9","977":"da75dba3"}[chunkId] + ".chunk.js";
};